import { ApplicationElement, html } from '@effectivastudio/lit-components';
import { ResizeController } from '@lit-labs/observers/resize-controller.js';
import style from './style.lit.css';
import '../group_item_2/element.js';

/**
 * Mini page header for group page - the title, should be passed as a child(innerHtml) most likely as an h2 tag.
 *
 * @prop name - Group title
 * @prop type - Type of the current group (options: open, private, closed)
 * @prop membersUrl - Url to group members page (optional)
 * @prop membersCount - Number of members
 * @prop region - region name for the origin component
 * @prop regionUrl - region url for the origin component
 * @prop regionIcon - region icon for the origin component if region image is not defined
 * @prop regionImage - region image for the origin component (optional)
 * @prop lead - Group lead, (optional)
 * @prop image - Group icon, (optional)
 * @prop highlighted - Represent if group is highlighted, (optional)
 *
 * @slot top - For lead title (optional)
 * @slot main - For the title
 * @slot right - For side actions (optional)
 */

export default class GroupHeaderMini extends ApplicationElement {
  static styles = [ApplicationElement.styles, style];

  static properties = {
    name: { type: String },
    type: { type: String },
    membersUrl: { type: String },
    membersCount: { type: Number },
    region: { type: String },
    regionUrl: { type: String },
    regionIcon: { type: String },
    regionImage: { type: String },
    lead: { type: String },
    image: { type: String },
    highlighted: { type: Boolean },
    isDesktop: { type: Boolean, state: true },
  };

  resizeObserver = new ResizeController(this, {
    callback: () => this.handleResize(),
  });

  handleResize() {
    this.isDesktop = window.innerWidth >= 768;
  }

  renderLead() {
    return html`<p slot="top">${this.lead}</p>`;
  }

  renderContent() {
    return html`
      ${this.lead ? this.renderLead() : null}
      <h2 slot="main">${this.name}</h2>
    `;
  }

  renderGroupItem() {
    return html`
      <xs-group-item-2
        .image=${this.image}
        .theme=${this.highlighted ? 'primary' : 'white'}>
        ${this.renderContent()}
      </xs-group-item-2>
      <slot name="right"></slot>
    `;
  }

  renderGroupItemExtended() {
    return html`
      <xs-group-item-2
        .image=${this.image}
        .theme=${this.highlighted ? 'primary' : 'white'}
        .type=${this.type}
        .membersUrl=${this.membersUrl}
        .membersCount=${this.membersCount}
        .region=${this.region}
        .regionIcon=${this.regionIcon}
        .regionUrl=${this.regionUrl}
        .regionImage=${this.regionImage}>
        ${this.renderContent()}
      </xs-group-item-2>
      <slot name="right"></slot>
    `;
  }

  render() {
    return this.isDesktop
      ? this.renderGroupItemExtended()
      : this.renderGroupItem();
  }
}

customElements.get('xs-group-header-mini') ||
  customElements.define('xs-group-header-mini', GroupHeaderMini);
